import NeedToSignNdaModal from './NeedToSignNdaModal.component';

export default NeedToSignNdaModal;
